export const RENEWAL_COUPON_ERROR_CODES = [
  'not_eligible',
  'renewal_payment_pending',
  'coupon_not_found',
  'coupon_expired',
  'coupon_exhausted',
  'coupon_invalid_for_plan',
  'coupon_invalid_for_recurrency',
  'coupon_not_assigned',
  'coupon_already_used',
  'coupon_not_better',
  'coupon_invalid',
] as const;

const CODES_LONGEST_FIRST = [...RENEWAL_COUPON_ERROR_CODES].sort(
  (a, b) => b.length - a.length,
);

/** Maps a backend error message to its i18n key; never exposes raw text. */
export function mapRenewalCouponError(message: string | null | undefined): string {
  const text = message ?? '';
  const code = CODES_LONGEST_FIRST.find((candidate) => text.includes(candidate));
  return `renewalCoupon.errors.${code ?? 'generic'}`;
}
